<div *ngIf="subscription">

  <!-- ✅ Trial banner — shown to all users in trial period -->
  <div class="ss__banner ss__banner--trial"
       *ngIf="subscription.isTrial && subscription.isTrialValid">
    <div class="ss__banner-left">
      <span class="ss__badge ss__badge--trial">TRIAL</span>
      <span class="ss__banner-text">
        <strong>
          {{ subscription.trialDaysRemaining }} day{{ subscription.trialDaysRemaining !== 1 ? 's' : '' }} remaining
        </strong>
        on your free trial — Professional plan features included.

        <span *ngIf="subscription.hasAiInsights">
          AI Insights:
          <strong>{{ subscription.aiInsightsRemaining }}</strong>
          of {{ subscription.aiInsightLimit }} remaining.
        </span>
      </span>
    </div>

    <button class="ss__upgrade-btn" (click)="goToPricing()">
      Upgrade Now
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
        <path d="M5 12H19M13 6L19 12L13 18"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
      </svg>
    </button>
  </div>

  <!-- ✅ Trial expired -->
  <div class="ss__banner ss__banner--expired"
       *ngIf="subscription.isTrial && !subscription.isTrialValid">
    <div class="ss__banner-left">
      <span class="ss__badge ss__badge--expired">TRIAL ENDED</span>
      <span class="ss__banner-text">
        Your free trial has expired. Upgrade to keep full access.
      </span>
    </div>

    <button class="ss__upgrade-btn" (click)="goToPricing()">
      Choose a Plan
    </button>
  </div>

  <!-- ✅ Free plan upgrade prompt -->
  <div class="ss__banner ss__banner--upgrade"
       *ngIf="showUpgradePrompt">
    <div class="ss__banner-left">
      <span class="ss__badge ss__badge--free">FREE</span>
      <span class="ss__banner-text">
        You are on the Free plan — 3 workers, 5 jobs, watermarked PDFs.
      </span>
    </div>

    <button class="ss__upgrade-btn" (click)="goToPricing()">
      Upgrade Now
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
        <path d="M5 12H19M13 6L19 12L13 18"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
      </svg>
    </button>
  </div>

  <!-- ✅ Expiry warning -->
  <div class="ss__banner ss__banner--warning"
       *ngIf="showExpiryWarning">
    <div class="ss__banner-left">
      <span class="ss__badge" [class]="planBadgeClass">
        {{ subscription?.plan }}
      </span>
      <span class="ss__banner-text">
        Your subscription expires in
        <strong>{{ subscription?.daysRemaining }} days</strong>.
        Renew to keep full access.
      </span>
    </div>

    <button class="ss__upgrade-btn" (click)="goToPricing()">
      Renew
    </button>
  </div>

</div>